import React,{useState} from "react";
import OldCmpAddress from "./OldCmpAddress";
import NewCmpAddress from "./NewCmpAddress";
import Option from "../Option";
import BackButton from "../../../../../components/common/backbutton/BackButton";

const CompanyAddressChange = () => {
  const [turnOn, setTurnOn] = useState(true)


  return (
    <div className="px-10 lg:!px-14">
      <p className="text-primary-red font-Rakkas mt-7 text-center  font-semibold tracking-wide underline md:!text-3xl">
        Company Address Change
      </p>
      
        {/* <tr className=" flex space-x-6 text-primary-red text-base font-bold sm:text-lg">
          <td className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
            <label htmlFor="">पहिले नै हामीसंग आवद्ध भएको कम्पनी</label>
            <input type="radio" name="radio-btn" id=""
            onChange={()=> setTurnOn(true)}
            />
          </td>
          <td className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
            <label htmlFor="">नयाँ कम्पनी </label>
            <input type="radio" name="radio-btn" id=""
            onChange={()=> setTurnOn(false)}
            />
          </td>
        </tr> */}
        <Option setTurnOn={setTurnOn}/>
        
    
      <div className="flex justify-between">
        <p className="text-primary-blue font-Calistoga text-lg underline">
          1. Business Name & Other Details
        </p>
      </div>

     {   
      turnOn ?
        <OldCmpAddress/>:
        <NewCmpAddress/>}



    </div>
  );
};

export default CompanyAddressChange;
